<script lang="ts">
	/**
	 * Poster image for a landing demo, selected to match the resolution the
	 * live canvas will render. The browser selects the 1x or 2x asset from the
	 * same globally capped DPR range used by the canvas.
	 */
	let { base, imgClass }: { base: string; imgClass: string } = $props();
</script>

<picture>
	<img
		srcset="{base}-1x.webp 1x, {base}-2x.webp 2x"
		src="{base}-2x.webp"
		alt=""
		draggable="false"
		class={imgClass}
	/>
</picture>
